<template>
  <div>
    <div class="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
      <div class="sm:mx-auto sm:w-full sm:max-w-sm">
<!--        <img class="mx-auto h-10 w-auto" src="https://tailwindcss.com/plus-assets/img/logos/mark.svg?color=indigo&shade=600" alt="CloudLog" />-->
        <h2 class="mt-10 text-center text-2xl/9 font-bold tracking-tight text-gray-900">Войти</h2>
      </div>

      <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form class="space-y-6" action="#" method="POST" @submit.prevent="submitForm(e)">
          <div>
            <label for="login" class="block text-left text-sm/6 font-medium text-gray-900">Login</label>
            <div class="mt-2">
              <input type="text" name="login" id="login" v-model="formData.login" autocomplete="login" required="" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6" />
            </div>
          </div>

          <!--<div>
            <label for="email" class="block text-left text-sm/6 font-medium text-gray-900">Email</label>
            <div class="mt-2">
              <input type="email" name="email" id="email" v-model="formData.email" autocomplete="email" required="" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6" />
            </div>
          </div>-->

          <div>
            <div class="flex items-center justify-between">
              <label for="password" class="block text-sm/6 font-medium text-gray-900">Пароль</label>
              <div class="text-sm">
                <router-link :to="{ name: 'forgot' }" class="font-semibold text-indigo-600 hover:text-indigo-500">
                  Забыли?
                </router-link>
              </div>
            </div>

            <div class="mt-2">
              <input type="password" name="password" v-model="formData.password" id="password" autocomplete="current-password" required="" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6" />
            </div>
          </div>

          <div>
            <button type="submit" class="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Авторизоваться</button>
          </div>
          <div v-if="errors !== null" class="text-red-800">
            {{errors}}
          </div>
        </form>

        <p class="mt-10 text-left text-sm/6 text-gray-500">
          <span @click.prevent="fakeLogin">Нет аккаунта?</span>
          <br>
          <router-link :to="{ name: 'registration' }" class="font-semibold text-indigo-600 hover:text-indigo-500">
            Регистрация с 14 дненым пробным периодом
          </router-link>
        </p>
      </div>

    </div>
  </div>
</template>

<script>
import store from '@/store.js'

export default {
  name: 'AuthLoginPage',
  data() {
    return {
      store,
      errors: null,
      formData: {
        login: null,
        //email: null,
        password: null,
      }
    }
  },
  methods: {
    fakeLogin() {
      console.log("fakeLogin")
      this.store.commit('authorize', 'ougyftiyvubhljn;huugo8yg7')
    },
    submitForm: function () {
      this.$yandexMetrika.reachGoal("from-login-submit")

      console.log("submit")
      let c = this;
      c.errors = null;
      this.axios.post('/api/login', this.formData).then(function(response) {
        //console.log(response.data.accessToken);
        //console.log(response.data.refreshToken);
        c.store.commit('authorize', response.data.accessToken, response.data.refreshToken)
        //this.$router.push({ path: 'home' })
      }).catch(function(err) {
        console.log(err.status);
        if (err.status === 401) {
          c.errors = "Неверный логин или пароль"
          return;
        }
        console.log(err);
        c.errors = "Ошибка"
      });
    }
  }
}

</script>